/**
 * Escrituras de la lección deacon-1 (deberes del diácono). Texto de churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const deacon1TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-20-59',
    reference: 'Doctrina y Convenios 20:59',
    text: 'deben, sin embargo, amonestar, exponer, exhortar, enseñar e invitar a todos a venir a Cristo.',
    verses: [
      {
        verse: 59,
        text: 'deben, sin embargo, amonestar, exponer, exhortar, enseñar e invitar a todos a venir a Cristo.',
      },
    ],
    context: 'Deberes de maestros y diáconos: ministrar mediante la palabra y la invitación a Cristo.',
  },
  {
    id: 'dc-84-111',
    reference: 'Doctrina y Convenios 84:111',
    text: 'Y he aquí, los sumos sacerdotes deben viajar, y también los élderes y los presbíteros; mas los diáconos y los maestros deben ser nombrados para velar por la iglesia y para ser sus ministros residentes.',
    verses: [
      {
        verse: 111,
        text: 'Y he aquí, los sumos sacerdotes deben viajar, y también los élderes y los presbíteros; mas los diáconos y los maestros deben ser nombrados para velar por la iglesia y para ser sus ministros residentes.',
      },
    ],
    context: 'Los diáconos y maestros como ministros residentes que velan por la iglesia.',
  },
  {
    id: 'dc-107-85-87',
    reference: 'Doctrina y Convenios 107:85–87',
    text:
      'Y además, de cierto os digo, el deber del presidente del oficio de diácono es presidir a doce diáconos, sentarse en concilio con ellos y enseñarles sus deberes, edificándose el uno al otro conforme a lo indicado en los convenios; y también el deber del presidente del oficio de los maestros es presidir a veinticuatro maestros, y sentarse en concilio con ellos, enseñándoles los deberes de su oficio, cual se indican en los convenios. Y también el deber del presidente del Sacerdocio de Aarón es presidir a cuarenta y ocho presbíteros, sentarse en concilio con ellos y enseñarles los deberes de su oficio, cual se indica en los convenios.',
    verses: [
      {
        verse: 85,
        text: 'Y además, de cierto os digo, el deber del presidente del oficio de diácono es presidir a doce diáconos, sentarse en concilio con ellos y enseñarles sus deberes, edificándose el uno al otro conforme a lo indicado en los convenios;',
      },
      {
        verse: 86,
        text: 'y también el deber del presidente del oficio de los maestros es presidir a veinticuatro maestros, y sentarse en concilio con ellos, enseñándoles los deberes de su oficio, cual se indican en los convenios.',
      },
      {
        verse: 87,
        text: 'Y también el deber del presidente del Sacerdocio de Aarón es presidir a cuarenta y ocho presbíteros, sentarse en concilio con ellos y enseñarles los deberes de su oficio, cual se indica en los convenios.',
      },
    ],
    context: 'Presidencias de diáconos, maestros y el sacerdocio Aarónico.',
  },
  {
    id: '1-timothy-3-8-10',
    reference: '1 Timoteo 3:8–10',
    text:
      'Los diáconos, asimismo, deben ser honestos, de una sola palabra, no dados a mucho vino, no codiciosos de ganancias deshonestas, que retengan el misterio de la fe con limpia conciencia. Y estos también sean antes puestos a prueba; y entonces ministren como diáconos, si son irreprensibles.',
    verses: [
      {
        verse: 8,
        text: 'Los diáconos, asimismo, deben ser honestos, de una sola palabra, no dados a mucho vino, no codiciosos de ganancias deshonestas,',
      },
      {
        verse: 9,
        text: 'que retengan el misterio de la fe con limpia conciencia.',
      },
      {
        verse: 10,
        text: 'Y estos también sean antes puestos a prueba; y entonces ministren como diáconos, si son irreprensibles.',
      },
    ],
    context: 'Cualidades y prueba de los diáconos.',
  },
];
